import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from 'common/react/components/SvgIcon';
import { ImageElement } from './ImageElement';
import { getTranslation } from 'common/react/utils/translations';

const CAPTION_VARIANTS = {
    'ProgramCategory:Match Highlights': getTranslation(
        'label.fixtures.match-highlights'
    ),
    'ProgramCategory:Mini-Matches': getTranslation(
        'label.fixtures.mini-matches'
    ),
    'ProgramCategory:Match Replays': getTranslation(
        'label.fixtures.match-replays'
    ),
    'match-preview': getTranslation('label.fixtures.match-preview')
};

export const FixtureMediaThumbnail = ({ video, category }) => {
    const ref = useRef();

    const videoUrlParams = {
        pageSize: 50,
        tagNames: `ProgramCategory:${video.tags
            .find((item) => item.label.includes('ProgramCategory:'))
            ?.label.replace('ProgramCategory:', '')}`,
        references: `AFL_MATCH:${
            video.references.find((item) => item.type === 'AFL_MATCH')?.id
        },AFL_ROUND:${
            video.references.find((item) => item.type === 'AFL_ROUND')?.id
        }`
    };

    const videoLink = `${video.link}&${PULSE.core.url.buildQueryString(
        videoUrlParams
    )}`;

    const videoModalData = {
        contentId: video.id,
        mediaId: video.mediaId,
        mediaTitle: PULSE.app.templating.helper.cleanString(video.title),
        mediaDescription: PULSE.app.templating.helper.cleanString(
            video.description
        ),
        subtitle: PULSE.app.templating.helper.cleanString(video.subtitle),
        type: video.type,
        link: videoLink,
        publishFrom: video.publishFrom + 1,
        mediaDate: PULSE.app.templating.helper.getDateNice(video.publishFrom)
    };

    useEffect(() => {
        if (ref.current) {
            PULSE.app.VideoPlayerModal.createInstance(ref.current);
            ref.current.dataset.modalAdded = true;
        }
    }, []);

    return (
        <article className={`media-thumbnail`}>
            <div className="media-thumbnail__link">
                <a
                    ref={ref}
                    className={`media-thumbnail__absolute-link`}
                    data-ui-modal="#VideoModal"
                    href={videoLink}
                    data-content-id={video.id}
                    data-ui-args={JSON.stringify(videoModalData)}
                ></a>
                <header
                    className={`media-thumbnail__image-container placeholder placeholder--small placeholder--dark`}
                >
                    <ImageElement
                        ImageUrl={video.onDemandUrl}
                        ImageTitle={video.title}
                    />

                    <div className={`media-thumbnail__video-duration`}>
                        <SvgIcon
                            icon={'video-play-small'}
                            className={`icon media-thumbnail__duration-icon`}
                        />
                    </div>
                </header>
                <div className={`media-thumbnail__caption`}>
                    {CAPTION_VARIANTS[category]}
                </div>
            </div>
        </article>
    );
};

FixtureMediaThumbnail.propTypes = {
    video: PropTypes.object.isRequired,
    category: PropTypes.string
};
